import { useTranslation } from 'gatsby-plugin-react-i18next';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Link from '../Atoms/Link';
import ArrowButton from '../Atoms/ArrowButton';

const imageQuery = graphql`
query {
  locations: file(base: {eq: "locations.jpeg"}) {
    childImageSharp {
      gatsbyImageData(
        width: 1200,
        placeholder: DOMINANT_COLOR
      )
    }
  }
}
`;

const Locations = (() => {
  const { t } = useTranslation();
  const { locations } = useStaticQuery(imageQuery);

  return (
    <section className="py-12 px-4 lg:px-8">
      <div className="max-w-screen-2xl w-full mx-auto">
        <h2 className="font-cirka font-light text-xl text-left lg:text-center mb-12">{t('locations.heading')}</h2>
        <div className="grid lg:grid-cols-4 gap-5">
          <div className="bg-white p-8 h-80 md:h-auto flex flex-col">
            <h3 className="text-primary font-cirka text-4xl mb-8">{t('locations.spain')}</h3>
            <div className="font-roboto font-light">
              <div>{t('locations.spainAddress.0')}</div>
              <div>{t('locations.spainAddress.1')}</div>
              <div>{t('locations.spainAddress.2')}</div>
              <div>{t('locations.spainAddress.3')}</div>
            </div>
            <Link
              to="https://www.google.com/maps/place/CD+Barcelona/@41.3951729,2.159915,19z/data=!3m1!4b1!4m5!3m4!1s0x12a4a293ee5ec595:0x46d19c28c8ff2b2b!8m2!3d41.3951729!4d2.1604622"
              className="w-fit mt-auto"
            >
              <ArrowButton />
            </Link>
          </div>
          <div className="bg-white p-8 h-80 md:h-auto">
            <h3 className="text-primary font-cirka text-4xl mb-8">{t('locations.germany')}</h3>
            <div className="font-roboto font-light">{t('locations.germanyAddress')}</div>
          </div>
          <GatsbyImage image={locations && getImage(locations)} className="md:col-span-2" alt="locations" />
        </div>
      </div>
    </section>
  );
})

export default Locations;
